<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <el-row class="m-t-20 p-20 block" type="flex" justify="space-between" align="center">
      <div class="flex-box column">
        <h1>创建新通知</h1>
      </div>
      <div class="flex-box row">
        <el-button type="success" size="cons" :loading="leavebtn.loading" @click="onleave()">返回
        </el-button>
      </div>
    </el-row>
    <el-row class="m-t-20 p-20 block">
      <el-form :model="detail" label-width="100px">
        <el-form-item v-for="item in form" :label="item.name" :prop="item.prop" :key="item.prop">
          <span v-if="item.prop === 'admin'" class="p-l-20"
                style="display:inline-block">{{detail[item.prop]}}</span>
          <el-input v-else-if="item.prop === 'title'" v-model="detail[item.prop]"></el-input>
          <el-select v-else-if="item.prop === 'department'" v-model="detail[item.prop]" placeholder="发布部门">
            <el-option v-for="label in form[1].select" :label="label" :value="label"
                       :key="label"></el-option>
          </el-select>
          <el-input v-else-if="item.prop === 'content'" :autosize="{ minRows: 5, maxRows: 8}" type="textarea"
                    v-model="detail[item.prop]"></el-input>
          <el-upload
            v-else-if="item.prop === 'attachment'"
            drag
            action=""
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
          <el-row v-else-if="item.prop === 'receiver'">
            <div class="block bodered">
              <el-tag
                v-for="receiver in detail[item.prop]"
                class="m-r-10"
                :key="receiver"
                type="gray"
              >{{receiver}}
              </el-tag>
              <div class="block segment">
                <span>按角色</span>
                <el-checkbox-group v-model="detail[item.prop]" size="small">
                  <el-checkbox v-for="role in form[5].select.role" :label="role" :key="role">
                    {{role}}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="block segment">
                <span>按部门</span>
                <el-checkbox-group v-model="detail[item.prop]" size="small">
                  <el-checkbox v-for="role in form[5].select.dept" :label="role" :key="role">
                    {{role}}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-row>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row class="m-t-20 p-20 block" type="flex" justify="space-between">
      <div class="flex-box row">
        <el-button type="primary" :loading="onlySavebtn.loading" @click="onOnlySave()">仅保存</el-button>
        <el-button type="success" :loading="saveAndPublishbtn.loading" @click="onsaveandpublish()">
          保存并发布
        </el-button>
      </div>
      <div class="flex-box row">
        <el-button type="danger" :loading="deletebtn.loading" @click="ondelete()">取消创建/删除</el-button>
      </div>
    </el-row>
  </div>
</template>

<script>
import * as Notice from 'api/notice'

export default {
  data () {
    return {
      ready: false,
      detail: null,
      form: null,
      status: null,
      onlySavebtn: {
        loading: false,
      },
      saveAndPublishbtn: {
        loading: false,
      },
      deletebtn: {
        loading: false,
      },
      leavebtn: {
        loading: false,
      },
      leaveType: null,
      leaveType_init: false,
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [detail, status, form] = await Promise.all([Notice.get(this.$query.notice_uid), Notice.status(), Notice.form_create()])
        if (detail) this.detail = detail
        else this.detail = {receiver: []}
        this.leaveType = null
        this.form = form
        this.status = status
        this.ready = true
      })
    },
    async onOnlySave () {
      this.onlySavebtn.loading = true
      try {
        await Notice.onlySave(this.detail, this.$query.notice_uid)
        this.$message.success('通知草稿保存成功')
        this.leaveType = null
      } catch (e) {
        this.$handleError(e)
      } finally {
        this.onlySavebtn.loading = false
      }
    },
    async onsaveandpublish () {
      this.saveAndPublishbtn.loading = true
      try {
        let uid = await Notice.saveAndPublish(this.detail, this.$query.notice_uid)
        this.leaveType = 'save_and_publish'
        this.$router.push(this.$location.notice_detail({notice_uid: uid}))
        this.$message.success('通知发布成功')
      } catch (e) {
        this.$handleError(e)
      } finally {
        this.saveAndPublishbtn.loading = false
      }
    },
    async ondelete () {
      let confirm = await this.$confirm('此操作将删除该通知, 是否继续?', '提示', {
        confirmButtonText: '删除',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: '取消',
        type: 'warning',
      })
      if (!confirm) return
      this.deletebtn.loading = true
      try {
        await Notice.cancelOrDelete(this.detail, this.$query.notice_uid)
        this.leaveType = 'delete'
        this.$router.push(this.$location.notice_list({}, false))
        this.$message.success('删除成功')
      } catch (e) {
        this.$handleError(e)
      } finally {
        this.deletebtn.loading = false
      }
    },
    async onleave () {
      this.$router.push(this.$location.notice_list({}, false))
    },
  },
  created () {
    this.init()
  },
  async beforeRouteLeave (to, from, next) {
    if (this.leaveType !== 'modified') return next()
    let confirm = await this.$confirm('您将要离开本页，是否保存通知草稿?', '提示', {
      confirmButtonText: '保存',
      confirmButtonClass: 'el-button--success',
      cancelButtonText: '取消',
      type: 'warning',
    })
    if (!confirm) return
    this.leavebtn.loading = true
    try {
      await Notice.onlySave(this.detail, this.$query.notice_uid)
      this.leaveType = 'normal'
      this.$router.push(this.$location.notice_list({}, false))
      this.$message.success('保存成功')
    } catch (e) {
      this.$handleError(e)
    } finally {
      this.leavebtn.loading = false
    }
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
    detail: {
      handler (val, oldVal) {
        if (this.leaveType_init) {
          this.leaveType = 'modified'
        } else {
          this.leaveType_init = true
        }
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss">
.flex-box.column {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.flex-box.row {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.block {
  background-color: white;
  .status0 {
    color: red;
    font-weight: bold;
  }

  .status1 {
    color: deepskyblue;
    font-weight: bold;
  }
}

.block.bodered {
  @extend .block;
  border: 1px solid rgb(191, 206, 217);
  border-radius: 4px;
  padding: 5px 7px 5px 7px;
}

.block.segment {
  @extend .block;
  border-top: 1px solid rgb(191, 206, 217);
  padding: 10px 0 10px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/notice/NoticeEdit.vue